import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { TotalPerCurrencyFilter } from './total-per-currency-filter.model';

export const TOTAL_PER_CATEGORY_FILTER_SCHEMA = Object.freeze({
  CATEGORY: '',
  TOTALS: List<TotalPerCurrencyFilter>([]),
});
const RECORD = generateSchema(TOTAL_PER_CATEGORY_FILTER_SCHEMA);
const KEYS: any = generateKeys(TOTAL_PER_CATEGORY_FILTER_SCHEMA);

export class TotalPerCategoryFilter extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.TOTALS,
        value: props.get(KEYS.TOTALS)
          ? this.totals.map((params) => new TotalPerCurrencyFilter(params))
          : List<TotalPerCurrencyFilter>([]),
      },
    ]);

    return selfModel as TotalPerCategoryFilter;
  }

  get category(): string {
    return this.get(KEYS.CATEGORY);
  }

  get totals(): List<TotalPerCurrencyFilter> {
    return this.get(KEYS.TOTALS);
  }
}
